const helpers = {};

helpers.debounce = (context, f, ms) => {

    let timer = null;

    return function (...args) {
        const onComplete = () => {
            f.apply(context, args);
            timer = null;
        };

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(onComplete, ms);
    };
};

helpers.throttle = (context, f, ms) => {

    let timer = null;

    return function (...args) {
        const onComplete = () => {
            f.apply(context, args);
            timer = null;
        };

        if (!timer) {
            timer = setTimeout(onComplete, ms);
        }

    };
};

helpers.getParent = (target, selector, includeSelf = true) => {
    if (includeSelf && target.matches(selector)) {
        return target;
    }

    let parent = target.parentElement;
    while (parent !== null) {
        if (parent.matches(selector)) {
            return parent;
        }
        parent = parent.parentElement;
    }

    return null;
};

export default helpers;



// WEBPACK FOOTER //
// ./app/general/js/helpers.js